import React, { useEffect, useRef, useState } from "react";
import heic2any from "heic2any";

function Preview({ path, generatedImage, setBolb, isGenerating }) {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (generatedImage) {
			initCanvasWithGeneratedImage(generatedImage);
		} else {
			initCanvas(path);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [generatedImage]);

	const canvas = useRef(null);

	function clearCanvas() {
		const c = canvas.current;
		const cxt = c.getContext("2d");
		cxt.clearRect(0, 0, c.width, c.height);
		cxt.fillStyle = "#fff";
		cxt.fill();
	}

	function initCanvas(path) {
		clearCanvas();

		let photo = new Image();
		if (path && path.name) {
			if (path.name.toLowerCase().endsWith(`.heic`)) {
				// toBuffer
				const fileReaderBuffer = new FileReader();
				fileReaderBuffer.readAsArrayBuffer(path);
				fileReaderBuffer.addEventListener("load", () => {
					setLoading(true);
					heic2any({
						blob: path,
						toType: "image/jpg",
					}).then((bolb) => {
						photo.src = URL.createObjectURL(bolb);
						setLoading(false);
					});
				});
			} else {
				photo.src = URL.createObjectURL(path);
			}
		} else {
			photo.src = require("../../../asset/img/example_canvas.jpeg");
		}

		// Create canvas
		photo.onload = function () {
			const c = canvas.current;
			const ctx = c.getContext("2d");

			// 设置画布大小为照片原始大小
			c.width = photo.width;
			c.height = photo.height;

			// 绘制照片
			ctx.drawImage(photo, 0, 0, c.width, c.height);

			// 图片绘制完成
			setBolb(c.toDataURL("image/jpeg", 0.9));
		};
	}

	function initCanvasWithGeneratedImage(imageUrl) {
		clearCanvas();

		let photo = new Image();
		photo.src = imageUrl;

		// Create canvas
		photo.onload = function () {
			const c = canvas.current;
			const ctx = c.getContext("2d");

			// 设置画布大小为照片原始大小
			c.width = photo.width;
			c.height = photo.height;

			// 绘制照片
			ctx.drawImage(photo, 0, 0, c.width, c.height);

			// 图片绘制完成
			setBolb(c.toDataURL("image/jpeg", 0.9));
		};
	}

	return (
		<div className="w-full relative md:w-1/2 lg:w-3/5 h-full p-6 md:rounded-2xl bg-gray-100 flex justify-center items-center">
			<div className={`absolute w-full h-full flex flex-col items-center justify-center inset-0 bg-gray-300 z-20 rounded-2xl !overflow-hidden transition-opacity ${isGenerating ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
				<span className="text-white text-center text-xl font-light z-30">Magic is on your way...</span>
        <div id="preview-overlay" />
			</div>
			<canvas
				ref={canvas}
				className="max-h-full max-w-full object-scale-down"></canvas>
		</div>
	);
}

export default Preview;
